import { render, staticRenderFns } from "./DefaultWithFilters.vue?vue&type=template&id=c5e7c7a4&lang=pug&"
import script from "./DefaultWithFilters.vue?vue&type=script&lang=js&"
export * from "./DefaultWithFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports